<template>
  <svg
    class="highlight-check-active-icon"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="18" height="18" rx="9" transform="matrix(1 0 0 -1 0 18.344)" fill="#00DBA6" />
    <path
      d="M13.0838 5.34386L7.0425 12.0211C6.94325 12.1308 6.77098 12.1308 6.67173 12.0211L4.24939 9.34376H2.22656L5.55943 13.0275C6.25417 13.7953 7.46007 13.7953 8.1548 13.0275L15.1066 5.34386H13.0838Z"
      fill="black"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'HighlightCheckActiveIcon',
})
</script>

<style scoped lang="scss">
.highlight-check-active-icon {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
